import { useMutation } from '@tanstack/react-query'

import useQuery from '@shared/hooks/src/useQuery'
import { queryClient } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { handleError, hashToArray, QK } from '@shared/utils'

export function useTaskCreation() {
  return useMutation({
    mutationFn: (data) => API.tasks.create(data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: QK.patients.id(variables.task.patient_id).tasks.lists })
      queryClient.invalidateQueries({
        queryKey: QK.tasks.lists,
        predicate: ({ queryKey }) => {
          const { status } = queryKey[queryKey.length - 1]
          return Array.isArray(status) ? status.includes(variables.task.status) : status === variables.task.status
        },
      })
    },
    onError: handleError,
  })
}

export function useDiagnosis(options = {}) {
  return useQuery({
    queryKey: QK.providerTypes.list(),
    queryFn: () => API.platform.providerTypes.list(),
    select: (data) => {
      const uniqueDiagnoses = data
        .filter((providerType) => providerType.diagnosis && Object.keys(providerType.diagnosis).length > 0)
        .flatMap((providerType) => hashToArray(providerType.diagnosis).map((option) => ({ code: option.id, label: option.value })))
        .reduce((acc, diagnosis) => {
          // Use reduce to create unique diagnoses map
          acc.set(diagnosis.code, diagnosis)
          return acc
        }, new Map())

      // Convert back to array and sort
      return Array.from(uniqueDiagnoses.values()).sort((a, b) => a.code.localeCompare(b.code))
    },
    ...options,
  })
}
